import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import { addBonusStart, getRollOverBonusStart } from '../../../../store/redux-slices/bonus'
import { toast } from '../../../../components/Toast'

const useRolloverBonus = () => {
  const { loading, isFetching, rollOverBonusDetail } = useSelector((state) => state.bonus)
  const dispatch = useDispatch()

  const [state, setState] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: 'selection'
    }
  ])

  const deposit = (data) => {
    dispatch(addBonusStart({
      data: {
        ...data,
        bonusAmount: data?.bonusAmount
      },
      onSuccess: () => {
        toast("Bet Bonus added successfully", 'success')

        dispatch(getRollOverBonusStart())
      },
      onError: (message) => {
        toast(message, 'error')
      }
    }))
  }

  useEffect(() => {
    dispatch(getRollOverBonusStart())
  }, [])

  useEffect(() => {
    if (rollOverBonusDetail) {
      setState([{
        startDate: new Date(rollOverBonusDetail?.createdAt),
        endDate: new Date(rollOverBonusDetail?.updatedAt),
        key: 'selection'
      }])
    }
  }, [rollOverBonusDetail])

  return {
    deposit,
    state,
    setState,
    loading,
    isFetching,
    rollOverBonusDetail
  }
}

export default useRolloverBonus
